import FormRow from 'Components/FormRow';
import InputHandler from 'Components/InputHandler';
import * as React from 'react';

const BAEPForm = ({ formData }: IOwnProps): React.JSX.Element => (
  <FormRow title="general.date">
    <InputHandler
      type="PartialDate"
      editing={true}
      name="date"
      formData={formData}
      dateDefault="now"
      isNotCancellable={true}
    />
  </FormRow>
);

interface IOwnProps {
  formData: IFormData<IDocumentWithTypeV2<'baep'>>;
}

export default BAEPForm;
